// extracted by mini-css-extract-plugin
export default {"container":"aut_158XB","thumbnail":"aut_thu_2jmTy","title":"aut_tit_3PXDk","withBorder":"aut_wit_3S6ZM"};